import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralServiceService } from './general-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private router: Router, private generalService : GeneralServiceService) {}

  // Check if the user is authenticated by looking for the token in sessionStorage
  isAuthenticated(): boolean {
    return !!sessionStorage.getItem('token');  // Checking for token in sessionStorage
  }

  // Method to login (store auth token in sessionStorage)
  login(token: string): void {
    sessionStorage.setItem('token', token);  // Store the token in sessionStorage
  }

  logout(event : any){
    const email = sessionStorage.getItem("username")
    const location = sessionStorage.getItem("Location")
    if(event == "manual"){
      this.generalService.logout(email, location, event).subscribe({
        next: (response) => {
          console.log("Response is", response)
          this.router.navigate(['/login']);
        },
        error: (err) => {
          console.error('Login failed', err);
        }
      });
    }
    else{
      this.generalService.logoutSession(email, location, event).subscribe({
        next: (response) => {
          console.log("Response is", response)
          this.router.navigate(['/login']);
        },
        error: (err) => {
          console.error('Login failed', err);
        }
      });
    }
    sessionStorage.removeItem("Location")
    sessionStorage.removeItem("token")
    //this.router.navigate(['/login']);
  }

}
